import React, { useMemo } from 'react'
import clsx from 'clsx'

import styles from './WordsPracticeAnimatedProgressBar.module.scss'

type WordsPracticeAnimatedProgressBarProps = {
  isFull?: boolean
  itemsCount: number
  activeItemIndex: number
}

const WordsPracticeAnimatedProgressBar: React.FC<WordsPracticeAnimatedProgressBarProps> = ({
  isFull,
  itemsCount,
  activeItemIndex
}) => {
  const progress = useMemo(() => {
    if (isFull) return 100
    if (itemsCount <= 0) return 0

    return Math.min((activeItemIndex / itemsCount) * 100, 100)
  }, [isFull, itemsCount, activeItemIndex])

  return (
    <div className={styles.container}>
      <div
        className={clsx(styles.progressLine, progress >= 100 && styles.done)}
        style={{
          width: `${progress}%`
        }}
      />
    </div>
  )
}

export default React.memo(WordsPracticeAnimatedProgressBar)
